import { Route, Routes } from "react-router-dom";
import AdminHome from "./routes/AdminHome";
import ChildHome from "./routes/ChildHome";
import ConsentPage from "./routes/ConsentPage";
import NotFound from "./routes/NotFound";
import StatsHome from "./routes/StatsHome";

/**
 * Les deux zones sont separees des le depart : l'app du jeune ne doit jamais
 * offrir de chemin vers /admin (CLAUDE.md section 5).
 *
 * La page de consentement fait exception a la logique du reste : UNE ADRESSE
 * PAR LANGUE, et accessible sans etre connecte. Ce lien peut etre copie,
 * imprime ou transmis a un parent qui n'ouvrira jamais le jeu — il doit mener
 * au meme texte pour tout le monde, quelle que soit la langue choisie dans
 * l'application.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<ChildHome />} />
      <Route path="/consentement" element={<ConsentPage lang="fr" />} />
      <Route path="/consent" element={<ConsentPage lang="en" />} />
      <Route path="/admin" element={<AdminHome />} />
      {/* Troisième rôle : mot de passe distinct, aucune donnée personnelle. */}
      <Route path="/stat" element={<StatsHome />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
